import { NavLink, useMatch } from "react-router-dom";
import { NavItem } from "../../../common/helpers/navigation";

export const AdminNavItem = ({ ...props }: AdminNavProps): JSX.Element => {
    const match = useMatch(props.item.path);
    return (
        <li className={match ? "is-active has-text-weight-semibold" : "has-text-weight-semibold"}>
            <NavLink to={props.item.path}>
                {props.itemCount !== undefined && (
                    <div className="px-2 mr-2 has-background-white has-text-black is-bordered-top is-bordered-bottom">
                        {props.itemCount}
                    </div>
                )}
                {props.item.displayName}
            </NavLink>
        </li>
    );
};

interface AdminNavProps {
    item: NavItem;
    itemCount?: number;
}
